import {call, put} from 'redux-saga/effects';
import NotificationsActions from '../redux/NotificationsRedux';
import MessagesActions from '../redux/MessagesRedux';

export function * getNotifications(api, action) {
  const response = yield call(api.getNotifications, {...action.props});

  if (response.ok) {
    yield put(NotificationsActions.notificationsSuccess({...response.data, ...action.props}));
  } else {
    yield put(NotificationsActions.notificationsFailure(response.data && response.data.title ? response.data.title : response.problem));
    yield put(MessagesActions.messagesShow({type: 'error', code: response.status, title: response.data && response.data.title ? response.data.title : response.problem}));
  }
}
